export default __webpack_public_path__ + "static/media/team4.fc3e2c45.jpg";